<template>
  <div>

    <Navbar v-if="isHome" :isHome="isHome" :activeLink="$router.currentRoute.name"/>
    <Header v-if="isHome" :isHome="isHome" />

    <Header v-if="!isHome" :isHome="isHome" />
    <Navbar v-if="!isHome" :isHome="isHome" :activeLink="$router.currentRoute.name"/>


    <slot></slot>
    <Footer />
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'
import Navbar from './Navbar.vue'

export default {
    name: 'Layout',
    components: {
        Header, Footer, Navbar
    },
    data() {
        return {
            isHome: false
        }
    },
    mounted(){
        this.isHome = this.$router.currentRoute.name == 'home' ? true : false;
    },
    watch: {
        isHome() {
            if (this.isHome == true)
                document.querySelector('body').classList.add('homepage');
            else
                document.querySelector('body').classList.remove('homepage');
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
